import React, { createContext, useContext } from 'react';
import proptypes from 'prop-types';
import { useConfigService, ExperienceContext } from '@thd-nucleus/experience-context';
import { GatherMockData } from '../common/utils/ContextUtils';
import { isAdmin } from '../common/utils/CardUtils';
import { createTiles } from '../common/utils/TileUtils';
import { useFetchHomepage, useFetchAvailablePerks } from '../hooks';
import { LoyaltyWelcomeCardModel } from '../common/models/UserInfoModels';

const { bool: boolType, object: objectType, func: funcType } = proptypes;

export const WelcomeCardContext = createContext({});

WelcomeCardContext.propTypes = {
  isAdmin: boolType,
  isLoading: boolType,
  userDataError: boolType,
  userData: objectType,
  challengesData: objectType,
  tiles: objectType,
  refreshData: funcType,
  sweepstakes: objectType,
  hasSweepstakesData: boolType,
  showSweepstakesTile: boolType,
  sweepstakesData: objectType,
};

export const WelcomeCardProvider = ({ children, componentName }) => {
  const { userData, refreshData, isLoading, userDataError } = useFetchHomepage();
  const {
    availablePerksData, refreshAvailablePerks,
    refreshAvailableOffers, isLoadingPerks, availablePerksError
  } = useFetchAvailablePerks();
  const { channel } = useContext(ExperienceContext);

  const isChildAccountEnabled = ['1', 1].includes(useConfigService('ENABLE_CHILD_ACCOUNT_CHANGES'));
  const isChildAccount = isChildAccountEnabled && userData?.customerInfo?.isChildAccount;
  const isSweepstakesEnabled = ['1', 1].includes(useConfigService('ENABLE_SWEEPSTAKES'));
  const showSweepstakesTile = isSweepstakesEnabled;
  const sweepstakesData = availablePerksData?.sweepstakes?.[0] || {};

  const contextValue = {
    isAdmin: isAdmin(),
    isLoading,
    userDataError,
    userData,
    availablePerksData,
    isLoadingPerks,
    isChildAccount,
    isSweepstakesEnabled,
    showSweepstakesTile,
    sweepstakesData,
    tiles: createTiles({
      isAdmin: isAdmin(),
      userData,
      availablePerksData,
      isLoadingPerks,
      availablePerksError,
      refreshAvailablePerks,
      refreshAvailableOffers,
      showSweepstakesTile,
      sweepstakesData,
      channel,
      componentName
    }),
    refreshData,
  };

  return <WelcomeCardContext.Provider value={contextValue}>{children}</WelcomeCardContext.Provider>;
};

WelcomeCardProvider.displayName = 'WelcomeCard Provider';
WelcomeCardProvider.dataModel = LoyaltyWelcomeCardModel;

export const exportsForTesting = {
  GatherMockData,
};